import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import Product from "../components/Product";
import Navbar from "../components/Navbar";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { useDispatch, useSelector } from "react-redux";
import { productList } from "../redux/slices/productSlice";
import { categoryList } from "../redux/slices/categorySlice";
import { add } from "../redux/slices/cartSlice"; // Added missing import
import { motion, AnimatePresence } from "framer-motion";
import { FiFilter, FiChevronDown, FiChevronUp, FiSearch } from "react-icons/fi";
import { HiOutlineAdjustments } from "react-icons/hi";
import { IoGridOutline, IoListOutline } from "react-icons/io5";
import { BsWhatsapp } from "react-icons/bs"; // Added missing import
import { AiOutlinePlusCircle, AiOutlineShoppingCart } from "react-icons/ai"; // Added missing imports

const AllProducts = () => {
  const products = useSelector((state) => state.products.data);
  const categories = useSelector((state) => state.category.data);
  const cart = useSelector((state) => state.cart.basket); // Added missing cart selector
  const dispatch = useDispatch();
  const [view, setView] = useState("grid"); // 'grid' or 'list'
  const [showFilters, setShowFilters] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  const { name = "all", category = "all" } = useParams();

  const getFilterUrl = (filter) => {
    const filterCategory = filter.category || category;
    const filterName = filter.name || name;
    return `/search/category/${filterCategory}/name/${filterName}`;
  };

  const selectedCategory = categories?.find((cat) => cat.title === category);

  useEffect(() => {
    dispatch(categoryList());
    dispatch(
      productList({
        name: name !== "all" ? name : "",
        category: category !== "all" ? category : "",
      })
    );
  }, [dispatch, category, name]);

  // Apply local search filter
  const filteredProducts = searchTerm
    ? products?.filter(
        (product) =>
          product?.title?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          product?.category?.toLowerCase().includes(searchTerm.toLowerCase())
      )
    : products;

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <Navbar />

      {/* Page title and search bar */}
      {/* <div className="bg-gradient-to-r from-blue-50 to-indigo-50 py-8">
        <div className="container mx-auto max-w-7xl px-4">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <h1 className="text-2xl md:text-3xl font-bold text-gray-800">
              {category !== "all"
                ? `${selectedCategory?.title} Məhsulları`
                : "Bütün Məhsullar"}
            </h1>

            <div className="relative flex-1 max-w-md">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <FiSearch className="h-5 w-5 text-gray-400" />
              </div>
              <input
                type="text"
                className="block w-full pl-10 pr-3 py-2.5 border border-gray-200 rounded-full bg-white focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                placeholder="Məhsulları axtar..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
          </div>
        </div>
      </div> */}

      <section className="py-8">
        <div className="container mx-auto max-w-7xl px-4">
          {/* Filter tools and view switcher */}
          <div className="flex flex-wrap items-center justify-between mb-6 gap-3">
            <button
              onClick={() => setShowFilters(!showFilters)}
              className="inline-flex items-center px-4 py-2 bg-white border border-gray-200 rounded-lg shadow-sm text-gray-700 hover:bg-gray-50 md:hidden"
            >
              <HiOutlineAdjustments className="mr-2" />
              <span>Filterlər</span>
              {showFilters ? (
                <FiChevronUp className="ml-2" />
              ) : (
                <FiChevronDown className="ml-2" />
              )}
            </button>

            <div className="flex items-center bg-white rounded-lg border border-gray-200 p-1">
              <button
                onClick={() => setView("grid")}
                className={`p-2 rounded ${
                  view === "grid"
                    ? "bg-blue-50 text-blue-600"
                    : "text-gray-500 hover:text-gray-700"
                }`}
              >
                <IoGridOutline className="w-5 h-5" />
              </button>
              <button
                onClick={() => setView("list")}
                className={`p-2 rounded ${
                  view === "list"
                    ? "bg-blue-50 text-blue-600"
                    : "text-gray-500 hover:text-gray-700"
                }`}
              >
                <IoListOutline className="w-5 h-5" />
              </button>
            </div>
          </div>

          <div className="flex flex-col md:flex-row gap-8">
            {/* Mobile filters */}
            <AnimatePresence>
              {showFilters && (
                <motion.div
                  initial={{ height: 0, opacity: 0 }}
                  animate={{ height: "auto", opacity: 1 }}
                  exit={{ height: 0, opacity: 0 }}
                  transition={{ duration: 0.3 }}
                  className="md:hidden w-full overflow-hidden"
                >
                  <div className="bg-white rounded-xl shadow-md p-4 mb-6">
                    <div className="flex justify-between items-center mb-4">
                      <h3 className="font-semibold text-gray-800">Kategoriyalar</h3>
                      <Link
                        to="/allproducts"
                        className="text-sm text-blue-600 hover:text-blue-800"
                      >
                        Sıfırla
                      </Link>
                    </div>

                    <div className="space-y-2">
                      {categories?.map((cat) => (
                        <Link
                          key={cat?._id}
                          to={getFilterUrl({ category: cat?.title })}
                          className={`flex items-center justify-between p-3 rounded-lg transition-colors ${
                            cat.title === selectedCategory?.title
                              ? "bg-blue-50 text-blue-700"
                              : "hover:bg-gray-50"
                          }`}
                        >
                          <div className="flex items-center">
                            <input
                              type="checkbox"
                              id={`mobile-${cat?._id}`}
                              checked={cat.title === selectedCategory?.title}
                              className="h-4 w-4 rounded text-blue-600 focus:ring-blue-500"
                              readOnly
                            />
                            <label
                              htmlFor={`mobile-${cat?._id}`}
                              className="ml-3 text-sm font-medium text-gray-700"
                            >
                              {cat?.title}
                            </label>
                          </div>
                          <span className="text-sm font-medium bg-amber-100 text-amber-700 px-2 py-1 rounded-full">
                            {cat?.productCount}
                          </span>
                        </Link>
                      ))}
                    </div>
                  </div>
                </motion.div>
              )}
            </AnimatePresence>

            {/* Desktop sidebar filters */}
            <div className="hidden md:block w-64 flex-shrink-0">
              <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden sticky top-24">
                <div className="p-4 border-b border-gray-100 bg-gray-50">
                  <h3 className="font-semibold text-gray-800 flex items-center">
                    <FiFilter className="mr-2" /> Kategoriyalar
                  </h3>
                </div>

                <div className="p-4">
                  <Link
                    to="/allproducts"
                    className="mb-4 block w-full py-2 px-4 bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 text-white text-center rounded-lg transition-colors font-medium text-sm"
                  >
                    Sıfırla
                  </Link>

                  <div className="space-y-1 mt-4">
                    {categories?.map((cat) => (
                      <Link
                        key={cat?._id}
                        to={getFilterUrl({ category: cat?.title })}
                        className={`flex items-center justify-between p-2.5 rounded-lg transition-colors ${
                          cat.title === selectedCategory?.title
                            ? "bg-blue-50 text-blue-700"
                            : "hover:bg-gray-50"
                        }`}
                      >
                        <div className="flex items-center">
                          <input
                            type="checkbox"
                            id={cat?._id}
                            checked={cat.title === selectedCategory?.title}
                            className="h-4 w-4 rounded text-blue-600 focus:ring-blue-500"
                            readOnly
                          />
                          <label
                            htmlFor={cat?._id}
                            className="ml-3 text-sm font-medium text-gray-700"
                          >
                            {cat?.title}
                          </label>
                        </div>
                        <span className="text-xs font-medium bg-amber-100 text-amber-700 px-2 py-1 rounded-full">
                          {cat?.productCount}
                        </span>
                      </Link>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            {/* Products grid */}
            <div className="flex-1">
              {filteredProducts?.length === 0 ? (
                <div className="flex flex-col items-center justify-center bg-white rounded-xl shadow-sm p-12 text-center">
                  <svg
                    className="w-16 h-16 text-gray-300 mb-4"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                    ></path>
                  </svg>
                  <h3 className="text-gray-700 font-medium text-lg mb-2">
                    Məhsul tapılmadı
                  </h3>
                  <p className="text-gray-500">
                    Başqa kateqoriya seçə və ya axtarış sözünü dəyişə bilərsiniz.
                  </p>
                </div>
              ) : view === "grid" ? (
                <motion.div
                  className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ duration: 0.3 }}
                >
                  {filteredProducts?.map((product) => (
                    <Product
                      product={product}
                      key={product?._id}
                      newProducts={products?.slice(0, 4)}
                    />
                  ))}
                </motion.div>
              ) : (
                <motion.div
                  className="space-y-4"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ duration: 0.3 }}
                >
                  {filteredProducts?.map((product) => (
                    <div
                      key={product?._id}
                      className="flex flex-col sm:flex-row bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden hover:shadow-md transition-shadow"
                    >
                      <Link
                        to={`/product/${product?.slug}`}
                        className="sm:w-40 md:w-56 h-48 bg-white flex-shrink-0"
                      >
                        <img
                          src={product?.image}
                          alt={product?.title}
                          className="w-full h-full object-contain p-4"
                          onError={(e) => {
                            e.target.src = "https://via.placeholder.com/300?text=No+Image";
                          }}
                        />
                      </Link>

                      <div className="flex-1 p-4 flex flex-col">
                        {product?.category && (
                          <span className="mb-2 text-xs bg-blue-50 text-blue-600 px-2 py-1 rounded-full inline-block w-fit font-medium">
                            {product?.category}
                          </span>
                        )}

                        <Link to={`/product/${product?.slug}`}>
                          <h3 className="text-lg font-semibold text-gray-800 mb-2 hover:text-blue-600 transition-colors">
                            {product?.title}
                          </h3>
                        </Link>

                        <div className="mt-auto">
                          <div className="flex justify-between items-end mb-4">
                            <div className="flex items-baseline">
                              <span className="font-bold text-xl sm:text-2xl text-gray-900">
                                {product?.price} ₼
                              </span>
                              <span className="ml-2 text-sm text-gray-500">
                                / {product?.unit || "ədəd"}
                              </span>
                            </div>
                          </div>

                          <div className="flex flex-wrap gap-3">
                            <button
                              onClick={() => {
                                const message = `Salam, Xoş gördük!\n${product?.title} məhsulunu sifariş etmək istəyirəm.\nMəhsulun linki: https://kabelmarket.az/product/${product?.slug}`;
                                const encodedMessage = encodeURIComponent(message);
                                window.open(
                                  `https://api.whatsapp.com/send?phone=994504071417&text=${encodedMessage}`
                                );
                              }}
                              className="py-2 px-4 bg-[#25d366] text-white rounded-lg flex items-center justify-center text-sm font-medium hover:bg-[#1ea952] transition-all"
                            >
                              <BsWhatsapp className="mr-2" />
                              Whatsapp
                            </button>

                            {cart?.find((item) => item?._id === product?._id) ? (
                              <button
                                disabled
                                className="py-2 px-4 bg-gray-100 text-gray-400 rounded-lg flex items-center justify-center text-sm font-medium border border-gray-200"
                              >
                                <AiOutlineShoppingCart className="mr-2" />
                                Səbətdə
                              </button>
                            ) : (
                              <button
                                onClick={() => dispatch(add({ ...product, qty: 1 }))}
                                className="py-2 px-4 bg-amber-400 text-gray-800 rounded-lg flex items-center justify-center text-sm font-medium hover:bg-amber-500 transition-all"
                              >
                                <AiOutlinePlusCircle className="mr-2" />
                                Səbətə at
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </motion.div>
              )}
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default AllProducts;
